(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["baroona-cricket-order-countdown"] && !Shopify.designMode) return;
  try {
    (() => {
  const pad = (value) => String(Math.max(0, value)).padStart(2, '0');
  document.querySelectorAll('[data-cricket-order-countdown]').forEach((panel) => {
    if (panel.dataset.countdownReady === 'true') return;
    panel.dataset.countdownReady = 'true';
    const cutoff = new Date(panel.dataset.cutoff).getTime();
    const timer = panel.querySelector('[data-cricket-timer]');
    const closed = panel.querySelector('[data-cricket-closed]');
    const update = () => {
      const remaining = cutoff - Date.now();
      if (!Number.isFinite(cutoff) || remaining <= 0) {
        if (timer) timer.hidden = true;
        if (closed) closed.hidden = false;
        return false;
      }
      const days = Math.floor(remaining / 86400000);
      const hours = Math.floor((remaining % 86400000) / 3600000);
      const minutes = Math.floor((remaining % 3600000) / 60000);
      const seconds = Math.floor((remaining % 60000) / 1000);
      panel.querySelector('[data-cricket-days]').textContent = pad(days);
      panel.querySelector('[data-cricket-hours]').textContent = pad(hours);
      panel.querySelector('[data-cricket-minutes]').textContent = pad(minutes);
      panel.querySelector('[data-cricket-seconds]').textContent = pad(seconds);
      return true;
    };
    update();
    const interval = window.setInterval(() => {
      if (!update()) window.clearInterval(interval);
    }, 1000);
  });
})();
  } catch(e) { console.error(e); }
})();

})();
